<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Promotions
      </h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-index' })">
            <i class="fa fa-gift"></i> Promotions
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-config-index' })">
            <i class="fa fa-credit-card"></i> Payments
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <div class="box-title">
            <h3>{{ title }}</h3>
          </div>
        </div>

        <div class="box-body" style="overflow: unset;">
          <div class="row">
            <div class="col-12 col-md-12 col-lg-10">
              <div class="form-horizontal">
                <div class="form-group">
                  <label for="name"
                    class="col-sm-3 control-label">
                    Promo Name
                  </label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      v-model="form.name"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-description"
                    class="col-sm-3 control-label">
                    Payment Description
                  </label>

                  <div class="col-sm-9">
                    <textarea
                      disabled
                      v-model="form.description"
                      class="form-control"
                      row="6"
                    >
                    </textarea>
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-3 control-label">
                    Promo Type
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      disabled
                      v-model="form.type"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="days"
                    class="col-sm-3 control-label">
                    Days
                  </label>

                  <div class="col-sm-9">
                    <template v-for="item in days">
                      <label :key="item.value" class="col-checkbox-inline" :for="item.value">
                        <input type="checkbox"
                          disabled
                          :id="item.value"
                          :value="item.value"
                          v-model="form.days">
                          {{ item.label }}
                      </label>
                    </template>
                  </div>
                </div>

                <div class="form-group">
                  <label for="methods"
                    class="col-sm-3 control-label">
                    Payment Methods
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      disabled
                      id="methods"
                      name="methods"
                      v-model="form.payment_method"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-3 control-label">
                    Status
                  </label>

                  <div class="col-sm-9">
                    <v-select
                      disabled
                      v-model="form.is_enabled"
                      :options="statuses">
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-footer">
          <a class="btn btn-default pull-right"
            @click.prevent="back">
            Back
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import API_BASEURL from '@/config';

export default {
  name: 'PromoConfigView',

  data() {
    return {
      title: 'View Promo Payments',

      form: {
        id: null,
        name: null,
        description: null,
        type: [],
        days: [],
        payment_method: [],
        installment_tenor: [],
        is_enabled: {
          label: 'Active',
          value: 1,
        },
      },

      statuses: [
        {
          label: 'Active',
          value: 1,
        },
        {
          label: 'Inactive',
          value: 0,
        },
      ],

      types: [
        {
          label: 'Promo Code',
          value: 'promocode',
        },
      ],

      days: [
        {
          label: 'Mon',
          value: 1,
        },
        {
          label: 'Tue',
          value: 2,
        },
        {
          label: 'Wed',
          value: 3,
        },
        {
          label: 'Thu',
          value: 4,
        },
        {
          label: 'Fri',
          value: 5,
        },
        {
          label: 'Sat',
          value: 6,
        },
        {
          label: 'Sun',
          value: 7,
        },
      ],

      payments: [],
    };
  },

  methods: {
    back() {
      this.$router.go(-1);
    },

    getPaymentMethods() {
      return new Promise((resolve, reject) => {
        const config = {
          baseURL: API_BASEURL,
          params: {
            page: 1,
            perpage: 100,
          },
        };

        this.axios.get('/payments/v2/payment-method', config)
          .then((response) => {
            const { data } = response.data;
            data.forEach((item) => {
              this.payments.push({
                label: item.name,
                value: item.id,
              });
            });
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject(error);
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch available payment methods',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.getPaymentMethods();
              }
            });
          });
      });
    },

    fetch() {
      this.axios.get(`/promoconfigs/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;

          const typeData = [];
          if (data.type !== null && data.type.length > 0) {
            data.type.forEach((selected) => {
              this.types.forEach((item) => {
                if (item.value === selected) {
                  typeData.push(item);
                }
              });
            });
          }

          const paymentMethodData = [];
          if (data.payment_method !== null && data.payment_method.length > 0) {
            data.payment_method.forEach((selected) => {
              this.payments.forEach((item) => {
                if (item.value === selected.id) {
                  paymentMethodData.push(item);
                }
              });
            });
          }

          this.form.id = data.id;
          this.form.name = data.name;
          this.form.description = data.description;
          this.form.days = data.days;
          this.form.type = typeData;
          this.form.payment_method = paymentMethodData;

          if (data.is_enabled === 0) {
            this.form.is_enabled = {
              label: 'Inactive',
              value: 0,
            };
          }
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch promo config detail',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.fetch();
              }
            });
          }
        });
    },

    async init() {
      await this.getPaymentMethods();
      this.fetch();
    },
  },

  mounted() {
    this.init();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/promo/config/View.vue